import mirrorCreator from 'mirror-creator'

export const actionTypes = mirrorCreator([
  'FETCH_LEADS_REQUESTED',
  'FETCH_LEADS_SUCCEEDED',
  'FETCH_LEADS_FAILED',
], {prefix: 'leads/'})
